// extracted by mini-css-extract-plugin
export default {"container":"Clock_container__x-xKO","clock":"Clock_clock__xtjWm","span":"Clock_span__x+bqC"};